import { CustomTable } from "@/components/Tables/CustomTable"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import Modal from "@/pages/branches/Model"
import { columns } from "@/pages/branches/Columns"
import { useState } from "react"
import { CrudProvider } from "@/context/crudContext"
import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs"

export default function BranchList() {
  const breadcrumbs = [
    { label: "Dashboard", url: "/pos/dashboard" },
    { label: "Branches" },
  ]
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Branches</h5>

        <Breadcrumbs breadcrumbs={breadcrumbs} />
      </div>

      <CrudProvider>
        <TagTable />
      </CrudProvider>
    </>
  )
}

function TagTable() {
  return (
    <>
      <CustomTable
        label="Branches"
        columns={columns}
        view={false}
        apiPath="branches"
      />

      <Modal />
    </>
  )
}
